import {tryAsyncFunc} from "globals/functions/async.ts";
import ajax from "config/ajax.ts";
import {useLocation} from "react-router-dom";
import {Form, Formik} from "formik";
import Button from "components/atom/button/Button.tsx";
import LoadingContainer from "components/container/LoadingContainer.tsx";
import Input from "components/atom/Input.tsx";
import {useTranslation} from "react-i18next";
import designerPng from 'assets/images/designer.png'
import {Fragment, useState} from "react";

function ForgotPassword() {
    const location = useLocation()
    const {t} = useTranslation()

    const [hasSent, sentHasSent] = useState(false)


    const values = {
        email: ''
    }

    //if we redirect to the signup page
    if (location.state && location.state.email) {
        values.email = location.state.email
    }

    return (

        <div className="w-full">

            {hasSent && (
                <Fragment>
                    <img alt="" src={designerPng} className="mx-auto block h-[220px] w-auto"/>
                    <h2 className="pb-3 text-center font-semibold">
                        {t('auth.pleaseVerifyEmailAccount')}
                    </h2>
                    <Button small style="text" className="w-full"
                            onClick={() => sentHasSent(false)}
                    >
                        {t('restart')}
                    </Button>
                </Fragment>
            )}

            {!hasSent && (
                <Fragment>
                    <img alt="" src={designerPng} className="mx-auto block h-[220px] w-auto"/>
                    <h2 className="pb-3 text-center font-semibold">
                        {t('auth.forgotPwdTitle')}
                    </h2>
                    <p className="pb-6 text-center text-gray-400">
                        {t('auth.forgotPwdDescription')}
                    </p>
                    <Formik
                        initialValues={values}
                        validateOnChange={false}
                        validateOnBlur={false}
                        validate={values => {
                            const errors: Partial<{ [K in keyof typeof values]: string }> = {};//same keys as type but with string value
                            if (!values.email) {
                                errors.email = t('forms.errors.requiredEmail')
                            }
                            return errors;
                        }}
                        onSubmit={async (values, {setSubmitting, setStatus, setFieldError}) => {
                            setSubmitting(true);
                            setStatus(null);

                            const [_, err] = await tryAsyncFunc(ajax.post('/public/auth/forgot-pwd', {
                                email: values.email,
                            }))
                            setSubmitting(false);

                            if (err) {
                                const errData = err.response.data || {}
                                const errors = errData.errors || {}

                                if (errors.global) {
                                    setStatus(errors.global)
                                    delete errors.global
                                }

                                Object.keys(errors).forEach(errKey => {
                                    setFieldError(errKey, errors[errKey])
                                })
                                return
                            }

                            sentHasSent(true)
                        }}
                    >
                        {({isSubmitting, status}) => (
                            <LoadingContainer isLoading={isSubmitting} keepChildren>
                                <Form>
                                    <Input autoComplete="username" name="email" type="email" label={t('forms.email')}/>

                                    {status && (
                                        <p className="error block">{status}</p>
                                    )}
                                    <div className="mt-4 flex w-full flex-row items-center justify-center">
                                        <Button className="w-full" type="submit" disabled={isSubmitting}>
                                            {t('continue')}
                                        </Button>
                                    </div>
                                    <div className="mt-4 flex flex-row items-center justify-between gap-4">
                                        <Button small style="text" className="w-full"
                                                to={{pathname: location.pathname, hash: '#/auth/login'}}
                                        >
                                            {t('auth.login')}
                                        </Button>
                                        <Button small style="text" className="w-full"
                                                to={{pathname: location.pathname, hash: '#/auth/signup'}}
                                        >
                                            {t('auth.signup')}
                                        </Button>
                                    </div>
                                </Form>
                            </LoadingContainer>
                        )}
                    </Formik>
                </Fragment>
            )}
        </div>
    )
}

export default ForgotPassword
